import { motion } from "framer-motion";

export const Grain = () => <div className="mm-grain" aria-hidden="true" />;

// Scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line text reveal
export const RevealLines = ({ lines, className = "", lineClass = "", delay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClass}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
